import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import Slider from 'react-slick';
import { generateUEID } from '../../../helpers/generateID';
import ThemeContext from '../../../providers/ThemeProvider';
import SecondaryDeal from '../secondaryDeal';

const DealCarousel = ({ deals, isTravel }) => {
  const theme = useContext(ThemeContext);
  const primaryColorUrlencoded = encodeURIComponent(theme.colors.primary);
  const settings = {
    arrows: true,
    dots: false,
    infinite: false,
    lazyLoad: true,

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],

    slidesToScroll: 2,

    slidesToShow: 2,
    // true doesn't work
    speed: 500,
  };

  return (
    <>
      <div>
        {deals?.length > 0 && (
          <>
            <div
              className={classNames('deal-carousel', {
                'deal-carousel--is-travel': isTravel,
              })}
              key={generateUEID()}
            >
              <Slider {...settings}>
                {deals.map((deal) => {
                  return (
                    <div className="slider-deal" key={generateUEID()}>
                      <SecondaryDeal
                        deal={deal}
                        extraclasses={'auto-width'}
                        hideSplat
                        isXS
                        key={deal.id}
                        showWishlist={false}
                      />
                    </div>
                  );
                })}
              </Slider>
            </div>
          </>
        )}
      </div>
      <style global jsx>{`
        .slick-slider {
          margin: 0 auto;
          padding: 0 15px;
        }
        .slider-deal {
          padding: 10px;
        }
        @media (min-width: ${theme.breakpoints.xs}) {
          .slick-slider {
            width: 350px;
          }
          .deal-carousel--is-travel .slick-slider {
            width: 350px;
          }
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .slick-slider {
            width: 450px;
          }
          .deal-carousel--is-travel .slick-slider {
            width: 370px;
          }
        }
        @media (min-width: ${theme.breakpoints.lgUp}) {
          .slick-slider {
            width: 450px;
          }
          .deal-carousel--is-travel .slick-slider {
            width: 600px;
          }
        }
        @media (min-width: ${theme.breakpoints.xlUp}) {
          .slick-slider {
            width: 510px;
          }
          .deal-carousel--is-travel .slick-slider {
            width: 700px;
          }
        }

        .slick-list {
          padding-top: 2px;
          z-index: 9;
        }
        .slick-next,
        .slick-prev {
          height: 48px;
          width: 48px;
          z-index: 10;
        }
        .slick-next {
          right: -12px;
        }
        .slick-prev {
          left: -12px;
        }
        .slick-next:before {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'%3E%3Cpath fill='${primaryColorUrlencoded}' d='M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
        }
        .slick-prev:before {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'%3E%3Cpath fill='${primaryColorUrlencoded}' d='M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
        }
        .slick-next:before,
        .slick-prev:before {
          content: '';
          font-size: 15px;
          padding: 10px;
          height: 48px;
          width: 48px;
        }
      `}</style>
    </>
  );
};

export default DealCarousel;

DealCarousel.propTypes = {
  deals: PropTypes.array,
  isTravel: PropTypes.bool,
};
